export default function ShippingEstimator() {
  // validate postcode is 4 digits
  function validatePostcode(postcode) {
    const pattern = /^[0-9]{4}$/;
    return pattern.test(postcode);
  }

  // check if a postcode is inside a range string like "3000 – 3199, 3204 – 3999"
  function isPostcodeInRange(destinationPostcode, destinationPostcodesStr) {
    if (!destinationPostcodesStr) return false;

    const ranges = destinationPostcodesStr.split(',').map((r) => r.trim());

    return ranges.some((range) => {
      const rangeStr = String(range).trim();
      const postcodeNum = parseInt(destinationPostcode, 10);

      if (rangeStr.includes('–')) {
        // Handle ranges with en-dash
        const [from, to] = rangeStr
          .split('–')
          .map((p) => parseInt(p.trim(), 10));
        return postcodeNum >= from && postcodeNum <= to;
      } else if (rangeStr.includes('-')) {
        // Handle ranges with hyphen
        const [from, to] = rangeStr
          .split('-')
          .map((p) => parseInt(p.trim(), 10));
        return postcodeNum >= from && postcodeNum <= to;
      } else {
        // Single postcode
        return postcodeNum === parseInt(rangeStr, 10);
      }
    });
  }

  function getAuStateByPostcode(postcode) {
    var postcode = parseInt(postcode, 10);
    if (
      (postcode >= 1000 && postcode <= 1999) ||
      (postcode >= 2000 && postcode <= 2599) ||
      (postcode >= 2619 && postcode <= 2899) ||
      (postcode >= 2921 && postcode <= 2999)
    ) {
      return 'NSW';
    } else if (
      (postcode >= 200 && postcode <= 299) ||
      (postcode >= 2600 && postcode <= 2618) ||
      (postcode >= 2900 && postcode <= 2920)
    ) {
      return 'ACT';
    } else if (
      (postcode >= 3000 && postcode <= 3999) ||
      (postcode >= 8000 && postcode <= 8999)
    ) {
      return 'VIC';
    } else if (
      (postcode >= 4000 && postcode <= 4999) ||
      (postcode >= 9000 && postcode <= 9999)
    ) {
      return 'QLD';
    } else if (
      (postcode >= 5000 && postcode <= 5799) ||
      (postcode >= 5800 && postcode <= 5999)
    ) {
      return 'SA';
    } else if (
      (postcode >= 6000 && postcode <= 6797) ||
      (postcode >= 6800 && postcode <= 6999)
    ) {
      return 'WA';
    } else if (
      (postcode >= 7000 && postcode <= 7799) ||
      (postcode >= 7800 && postcode <= 7999)
    ) {
      return 'TAS';
    } else if (
      (postcode >= 800 && postcode <= 899) ||
      (postcode >= 900 && postcode <= 999)
    ) {
      return 'NT';
    }

    return '';
  }

  function getNZStateByPostcode(postcode) {
  // Convert to string and validate
  var postcodeStr = String(postcode);
  
  // Validate postcode (should be 4 digits for NZ street addresses)
  if (postcodeStr.length !== 4 || isNaN(postcode)) {
    return '';
  }
  
  // Get the first digit
  var firstDigit = postcodeStr[0];
  
  // Region map based on first digit - returning region codes
  var regionMap = {
    '0': 'NTL', // Northland, parts of Auckland
    '1': 'AUK', // Auckland
    '2': 'AUK', // Auckland, Waikato (predominantly Auckland for 20xx-21xx)
    '3': 'WKO', // Bay of Plenty, Waikato (predominantly Waikato/BOP)
    '4': 'MWT', // Gisborne, Hawke's Bay, Taranaki, Manawatu-Wanganui
    '5': 'WGN', // Wellington
    '6': 'WGN', // Wellington
    '7': 'CAN', // Tasman, Nelson, Marlborough, West Coast, Canterbury
    '8': 'CAN', // Canterbury
    '9': 'OTA'  // Otago, Southland
  };
  
  // Return the region code, or empty string if not found
  return regionMap[firstDigit] || '';
}

  return {
    error: '',
    deliveryRanges: [],
    deliveryTypes: [],
    destinationCountry: 'AU',
    pickUpAvailabilities: [], // Store availabilities with address and available status
    deliveryTypeResults: [],
    loading: false,
    currentVariantId: null,

    // initialize multiple metaobjects
    initMetaObjects(el) {
      const ranges = el.getAttribute('data-delivery-ranges');
      const types = el.getAttribute('data-delivery-types');
      const pickUpAvailabilities = el.getAttribute(
        'data-product-pick-up-availabilities',
      );
      const countryCode = el.getAttribute('data-country-code');
      this.destinationCountry = countryCode || 'AU';
      // Listen for size variant changes
      document.querySelectorAll('input[name="SIZE"]').forEach((input) => {
        input.addEventListener('change', async () => {
          // Delay slightly to ensure variant change has fully processed
          setTimeout(async () => {
            await this.reRenderShippingEstimator();
          }, 100);
        });
      });

      if (ranges) {
        try {
          this.deliveryRanges = JSON.parse(ranges);
        } catch (e) {
          console.error('Failed to parse deliveryRanges', e);
        }
      }

      if (types) {
        try {
          this.deliveryTypes = JSON.parse(types);
        } catch (e) {
          console.error('Failed to parse deliveryTypes', e);
        }
      }

      if (pickUpAvailabilities) {
        try {
          this.pickUpAvailabilities = JSON.parse(pickUpAvailabilities);
        } catch (e) {
          console.error('Failed to parse pickUpAvailabilities', e);
        }
      }

      // Add Enter key listener for postcode input
      const postcodeInput = document.getElementById('shipping-estimator-postcode');
      if (postcodeInput) {
        postcodeInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.estimatorHandler();
          }
        });
      }

      // Store the element reference for later use
      this.element = el;
    },

    getClosestPickupAvailabilityStore(postcode) {
      let destinationState = '';
      if(this.destinationCountry === 'NZ'){
        destinationState = getNZStateByPostcode(postcode);
      }
      if(this.destinationCountry === 'AU'){
        destinationState = getAuStateByPostcode(postcode);
      }

      if (!destinationState || !this.pickUpAvailabilities.length) {
        return null;
      }

      // Find all stores in the matching state
      const storesInState = this.pickUpAvailabilities.filter((store) => {
        const address = store.address;
        return address && address.province_code === destinationState;
      });

      if (storesInState.length === 0) {
        return null;
      }

      // Find the first AVAILABLE store in the matching state
      const availableStore = storesInState.find(
        (store) => store.available === true,
      );

      if (!availableStore) {
        return null; // Return null to trigger warehouse fallback
      }
      return availableStore.address; // Return the address object
    },

    getMatchedDeliveryTypes(ranges) {
      const deliveryTypeGidResultsSet = new Set();

      ranges.forEach((range) => {
        if (range.delivery_types && range.delivery_types.length > 0) {
          range.delivery_types.forEach((typeGid) => {
            deliveryTypeGidResultsSet.add(typeGid);
          });
        }
      });

      const deliveryTypeGidResults = Array.from(deliveryTypeGidResultsSet);

      return deliveryTypeGidResults
        .map((gidObj) => {
          const id = gidObj.split('/').pop();
          return this.deliveryTypes.find(
            (type) => type.delivery_type_id === id,
          );
        })
        .filter(Boolean);
    },

    // Method to re-render the shipping estimator section with updated variant data
    async reRenderShippingEstimator() {
      try {
        // Get current URL and variant ID
        const urlParams = new URLSearchParams(window.location.search);
        let variantId = urlParams.get('variant');

        // If no variant ID in URL, try to get it from the variant selects element
        if (!variantId) {
          const variantSelectsElement =
            document.querySelector('variant-selects');
          if (variantSelectsElement && variantSelectsElement.currentVariant) {
            variantId = variantSelectsElement.currentVariant.id;
          }
        }

        if (!variantId) {
          console.warn('No variant ID found in URL or variant selects');
          return;
        }

        // Find the shipping estimator container
        const shippingEstimatorContainer = document.getElementById(
          'product-shipping-estimator',
        );
        if (!shippingEstimatorContainer) {
          console.warn('Shipping estimator container not found');
          return;
        }

        // Get the section ID from the current page - try multiple approaches
        let sectionElement =
          shippingEstimatorContainer.closest('[data-section]');

        if (!sectionElement) {
          console.warn('Section element not found via data-section');
        }

        // Try to get section ID from various attributes
        let sectionId =
          sectionElement?.getAttribute('data-section') ||
          sectionElement?.getAttribute('data-section-id');

        if (!sectionId) {
          console.warn('Section ID not found');
          return;
        }

        // Build the section URL to fetch updated content
        const sectionUrl = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

        // Fetch the updated section content
        const response = await fetch(sectionUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch section: ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find the shipping estimator section in the fetched content
        const newShippingEstimator = doc.getElementById(
          'product-shipping-estimator',
        );
        if (newShippingEstimator) {
          // Replace the current shipping estimator with the new one
          shippingEstimatorContainer.outerHTML = newShippingEstimator.outerHTML;

          // Re-initialize the Alpine.js component on the new element
          const newElement = document.getElementById(
            'product-shipping-estimator',
          );
          if (newElement && window.Alpine) {
            // Trigger Alpine.js to re-initialize the component
            window.Alpine.initTree(newElement);
          }
        }
      } catch (error) {
        console.error('Error re-rendering shipping estimator:', error);
      }
    },

    // handler for click event
    async estimatorHandler() {
      const postcode = document.getElementById(
        'shipping-estimator-postcode',
      ).value;

      if (!postcode) {
        this.error = 'Please enter a postcode';
        setTimeout(() => {
          this.error = '';
        }, 3000);
        return;
      }
      if (!validatePostcode(postcode)) {
        this.error = 'Postcode must be 4 digits';
        setTimeout(() => {
          this.error = '';
        }, 3000);
        return;
      }
      this.error = '';
      this.loading = true;
      this.deliveryTypeResults = [];
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Get closest available pickup store
      // If store is not available (out of stock), this will return null
      const closestStore = this.getClosestPickupAvailabilityStore(postcode);

      if (closestStore) {
        // const sourceCountry = closestStore.country_code;
        // const closestStoreState = closestStore.province_code;
        const closestStorePostcode = closestStore.zip;

        const destinationPostcode = postcode;

        //get delivery ranges that match source and destination
        const matchedDeliveryRanges = this.deliveryRanges.filter(
          (range) =>
            range.source_country === this.destinationCountry &&
            // range.source_state === closestStoreState &&
            range.source_postcode === closestStorePostcode &&
            range.destination_country === this.destinationCountry &&
            isPostcodeInRange(destinationPostcode, range.destination_postcodes),
        );

        if (matchedDeliveryRanges.length !== 0) {
          this.deliveryTypeResults = this.getMatchedDeliveryTypes(
            matchedDeliveryRanges,
          );
          this.loading = false;
        } else {
          const matchedDeliveryRanges = this.deliveryRanges.filter(
            (range) =>
              range.default_warehouse === true &&
              range.destination_country === this.destinationCountry,
          );

          this.deliveryTypeResults = this.getMatchedDeliveryTypes(
            matchedDeliveryRanges,
          );
          this.loading = false;
        }
      } else {
        //use warehouse as fallback - either no store found or store is out of stock
        const matchedDeliveryRanges = this.deliveryRanges.filter(
          (range) =>
            range.default_warehouse === true &&
            range.destination_country === this.destinationCountry,
        );

        this.deliveryTypeResults = this.getMatchedDeliveryTypes(
          matchedDeliveryRanges,
        );
        this.loading = false;
      }
    },
  };
}
